import { formatColorName } from '@util/common.js';
import PropTypes from 'prop-types';

ColorPickerLabel.propTypes = {
  color: PropTypes.string.isRequired,
  labelText: PropTypes.string,
  className: PropTypes.string,
};

export default function ColorPickerLabel({
  color,
  labelText = 'Background color',
  className = '',
}) {
  return (
    <legend className={`fieldset-legend select-none pl-1 -mb-0.5 pb-0 mt-0 pt-0 ${className}`}>
      <span>
        {labelText}: <b>{formatColorName(color)}</b>
      </span>
    </legend>
  );
}
